import { hookstate } from '@hookstate/core'

export type AdditionalInfoState = {
  deliveryResourceAssigned: { id: string }
}

const initialState: AdditionalInfoState = {
  deliveryResourceAssigned: { id: '' }
}

const AdditionalInfoGlobalState = hookstate(initialState)

export { AdditionalInfoGlobalState }
